import { $win, $body } from "../utils/globals";
import 'slick-carousel';

initProductSliders();

function initProductSliders() {
  $('.js-product-slider').each( function() {
    let $this = $(this);

    $this.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      infinite: false,
      asNavFor: '.js-product-thumbs'
    });
  });

  $('.js-product-thumbs').each( function() {
    let $this = $(this);

    $this.slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      infinite: false,
      asNavFor: '.js-product-slider',
      focusOnSelect: true
    });
  });
}
